<template>
    <SideNav ref="sidenav" :check-close="close" class="feedback">
        <div class="header">
            <div class="corner">
                <div class="corner-inner">
                    <div class="back"></div>
                    <div class="title">Обращение в поддержку</div>
                </div>
            </div>

            <div class="adhoc">
                <div class="adhoc-wrapper">
                    <div class="adhoc-content">
                        <div class="close" @click="$refs.sidenav.cancel()"></div>
                    </div>
                </div>
            </div>
        </div>

        <template v-if="!saved">
            <div class="middle">
                <div class="switch-view">
                    <TheSwitch v-model="view" :elements="views" class="switch"/>
                </div>

                <component :is="view" ref="content"
                           @changed="changed = $event"/>
            </div>
            <div class="footer">
                <input class="ghost" type="button" value="Отмена" @click="$refs.sidenav.cancel()"/>
                <input :disabled="v.$invalid" class="primary" type="button" value="Отправить" @click="save" />
            </div>
        </template>

        <template v-else>
            <div class="middle">
                <div class="thanks">
                    <div class="text">
                        Спасибо за обращение! <br>
                        <template v-if="view === 'FeedbackContent'">
                            Ваше обращение будет рассмотрено в ближайшее время
                        </template>
                        <template v-else>
                            Запрос отправлен в техническую поддержку. Вы можете отслеживать обращение в Helpme,
                            либо в корпоративной почте
                        </template>
                    </div>

                    <div class="img"></div>
                </div>
            </div>
        </template>
    </SideNav>
</template>

<script>
import FeedbackContent from '@/common/page_comp/Feedback/FeedbackContent.vue';
import FeedbackTech from '@/common/page_comp/Feedback/FeedbackTech.vue';

import { useVuelidate } from '@vuelidate/core';

export default {
    name: 'Feedback',
    setup() {
        return {
            v: useVuelidate({ $autoDirty: true }),
        };
    },
    components: { FeedbackContent, FeedbackTech },
    data() {
        return {
            view: 'FeedbackContent',

            changed: false,
            saved: false,
        };
    },
    computed: {
        views() {
            return [
                { id: 'FeedbackContent', title: 'Проблема с контентом' },
                { id: 'FeedbackTech', title: 'Техническая проблема' },
            ];
        },
    },
    mounted() {
        if (this.$route.query.openedFeedbackSidenav) {
            this.open();
        }
    },
    methods: {
        async open(model = {}) {
            this.saved = false;
            await this.$nextTick();
            this.$refs.content.reset();
            this.$refs.content.setInnerState(model);
            this.$refs.sidenav.open();
        },
        close(sidenav) {
            if (!this.changed)
                return true;

            return sidenav.showConfirm();
        },
        async save() {
            if (this.v.$invalid)
                return;

            await this.$refs.content.save();
            this.saved = true;
            this.changed = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.feedback {
    .side-nav-inner {
        @media (max-width: 768px) {
            & > * {
                padding-right: 16px;
                padding-left: 16px;
            }
        }
    }

    .switch-view {
        margin-bottom: 20px;

        :deep(.switch) {
            overflow: hidden;
            max-width: 100%;
            width: 100%;

            .item {
                text-overflow: ellipsis;
                overflow: hidden;
                flex: 1;
                display: block;
                text-align: center;

                @media (max-width: 768px) {
                    font-size: 12px;
                }
            }
        }
    }

    .thanks {
        text-align: center;
        margin: 144px 82px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .text {
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
        }

        .img {
            width: 301px;
            height: 301px;
            margin-top: 20px;
            background-image: url('./image/feedback.png');
            background-size: cover;
        }
    }
}
</style>
